import React, { useState } from "react";
import "../css/FAQ.css";


export const faqData = [

  {
    question: "What is Ranthambore Safari?",
    answer: "Ranthambore Safari is a wildlife safari inside Ranthambore National Park conducted in open vehicles like Jeep (Gypsy) and Canter to explore wildlife and spot tigers."
  },

  {
    question: "What is the difference between Jeep Safari and Canter Safari?",
    answer: "Jeep Safari is a 6-seater open vehicle offering better flexibility and tiger sighting opportunities, while Canter Safari is a 20-seater vehicle ideal for groups and budget travelers."
  },

  {
    question: "What are Ranthambore Safari timings?",
    answer: "There are two safaris daily: Morning safari (approx. 6:30 AM – 10:00 AM) and Afternoon safari (approx. 2:30 PM – 6:00 PM). Timings vary depending on season."
  },

  {
    question: "How long does the safari last?",
    answer: "Each safari lasts approximately 3 to 3.5 hours."
  },

  {
    question: "Which safari is best for tiger sighting?",
    answer: "Jeep Safari is considered best for tiger sightings due to smaller size, flexibility, and access to better positions inside safari zones."
  },

  {
    question: "How many zones are there in Ranthambore National Park?",
    answer: "There are 10 safari zones in Ranthambore National Park. Zones 1 to 5 are core zones and have higher tiger sighting probability."
  },

  {
    question: "Can we choose safari zone manually?",
    answer: "Zone allocation is controlled by the forest department and depends on availability. Specific zones cannot be guaranteed."
  },

  {
    question: "Is tiger sighting guaranteed in Ranthambore?",
    answer: "Tiger sighting is not guaranteed because tigers live in natural habitat, but Ranthambore has one of the highest tiger sighting probabilities in India."
  },

  {
    question: "Is advance booking required for safari?",
    answer: "Yes, advance booking is highly recommended because safari seats get sold out quickly, especially during peak season."
  },

  {
    question: "What documents are required for safari booking?",
    answer: "A valid government ID proof such as Aadhaar Card, Passport, or Driving License is required at the time of booking and safari entry."
  },

  {
    question: "What is the difference between morning and afternoon safari?",
    answer: "Both safaris offer similar wildlife experience. Morning safari is cooler, while afternoon safari has good tiger movement near water sources."
  },

  {
    question: "What animals can be seen during safari?",
    answer: "Wildlife includes Bengal tiger, leopard, sloth bear, deer, crocodiles, wild boar, and various bird species."
  },

  {
    question: "Is safari safe for tourists?",
    answer: "Yes, safari is completely safe when conducted according to forest department rules and under guidance of trained driver and guide."
  },

  {
    question: "What should I wear during safari?",
    answer: "Wear comfortable clothes in natural colors like green, brown, or beige. Avoid bright colors."
  },

  {
    question: "Can children go on safari?",
    answer: "Yes, children are allowed on safari but must be accompanied by adults."
  },

  {
    question: "What happens if safari is cancelled?",
    answer: "If safari is cancelled due to park closure or government restrictions, refund or alternative options may be provided."
  },

  {
    question: "Which safari vehicle is better: Jeep or Canter?",
    answer: "Jeep Safari offers better experience and tiger sighting chances, while Canter Safari is more economical and ideal for groups."
  },

  {
    question: "How early should I arrive before safari?",
    answer: "You should arrive at reporting point at least 30 minutes before safari time."
  }



];




export default function FAQ() {

  const faqs = [


  {
    question: "What is Ranthambore Safari?",
    answer: "Ranthambore Safari is a wildlife safari inside Ranthambore National Park conducted in open vehicles like Jeep (Gypsy) and Canter to explore wildlife and spot tigers."
  },

  {
    question: "What is the difference between Jeep Safari and Canter Safari?",
    answer: "Jeep Safari is a 6-seater open vehicle offering better flexibility and tiger sighting opportunities, while Canter Safari is a 20-seater vehicle ideal for groups and budget travelers."
  },

  {
    question: "What are Ranthambore Safari timings?",
    answer: "There are two safaris daily: Morning safari (approx. 6:30 AM – 10:00 AM) and Afternoon safari (approx. 2:30 PM – 6:00 PM). Timings vary depending on season."
  },

  {
    question: "How long does the safari last?",
    answer: "Each safari lasts approximately 3 to 3.5 hours."
  },

  {
    question: "Which safari is best for tiger sighting?",
    answer: "Jeep Safari is considered best for tiger sightings due to smaller size, flexibility, and access to better positions inside safari zones."
  },

  {
    question: "How many zones are there in Ranthambore National Park?",
    answer: "There are 10 safari zones in Ranthambore National Park. Zones 1 to 5 are core zones and have higher tiger sighting probability."
  },

  {
    question: "Can we choose safari zone manually?",
    answer: "Zone allocation is controlled by the forest department and depends on availability. Specific zones cannot be guaranteed."
  },

  {
    question: "Is tiger sighting guaranteed in Ranthambore?",
    answer: "Tiger sighting is not guaranteed because tigers live in natural habitat, but Ranthambore has one of the highest tiger sighting probabilities in India."
  },

  {
    question: "Is advance booking required for safari?",
    answer: "Yes, advance booking is highly recommended because safari seats get sold out quickly, especially during peak season."
  },

  {
    question: "What documents are required for safari booking?",
    answer: "A valid government ID proof such as Aadhaar Card, Passport, or Driving License is required at the time of booking and safari entry."
  },

  {
    question: "What is the difference between morning and afternoon safari?",
    answer: "Both safaris offer similar wildlife experience. Morning safari is cooler, while afternoon safari has good tiger movement near water sources."
  },

  {
    question: "What animals can be seen during safari?",
    answer: "Wildlife includes Bengal tiger, leopard, sloth bear, deer, crocodiles, wild boar, and various bird species."
  },

  {
    question: "Is safari safe for tourists?",
    answer: "Yes, safari is completely safe when conducted according to forest department rules and under guidance of trained driver and guide."
  },

  {
    question: "What should I wear during safari?",
    answer: "Wear comfortable clothes in natural colors like green, brown, or beige. Avoid bright colors."
  },

  {
    question: "Can children go on safari?",
    answer: "Yes, children are allowed on safari but must be accompanied by adults."
  },

  {
    question: "What happens if safari is cancelled?",
    answer: "If safari is cancelled due to park closure or government restrictions, refund or alternative options may be provided."
  },

  {
    question: "Which safari vehicle is better: Jeep or Canter?",
    answer: "Jeep Safari offers better experience and tiger sighting chances, while Canter Safari is more economical and ideal for groups."
  },

  {
    question: "How early should I arrive before safari?",
    answer: "You should arrive at reporting point at least 30 minutes before safari time."
  }



  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {

    if (openIndex === index)
      setOpenIndex(null);
    else
      setOpenIndex(index);

  };

  return (

    <div className="faq-container">

      <h2 className="faq-title">
        Frequently Asked Questions
      </h2>

      {faqs.map((faq, index) => {

        const isOpen = openIndex === index;

        return (

          <div
            key={index}
            className={`faq-item ${isOpen ? "open" : ""}`}
          >

            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >

              <span>{faq.question}</span>

              <span className="faq-icon">
                {isOpen ? "−" : "+"}
              </span>

            </div>

            <div
              className={`faq-answer ${isOpen ? "show" : ""}`}
            >

              {faq.answer}

            </div>

          </div>

        );

      })}

    </div>

  );

}
